import { type ReactElement } from "react";
import type { SectionId } from "@/features/journal-title-sections";

type ValidationError = {
  id: number;
  description: string | ReactElement;
};

const ERROR_MAP: Record<SectionId, number[]> = {
  "journals-info": [1, 2, 3, 4],
  "developer-company": [5, 6, 15, 24, 34],
  "tec-customer-company": [7, 8, 26, 27],
  "building-contractor-company": [9, 10, 25],
  "documentation-contractor-company": [33, 30],
  "designer-supervisions": [16, 18, 31],
  "other-developers": [21, 32],
  "documentation-permission": [999],
  "documentation-examination": [998],
};

/**
 * Создает функцию для получения ошибок валидации конкретной секции
 * @param errorList - полный список ошибок валидации
 * @returns функция, которая принимает sectionId и возвращает ошибки для этой секции
 */
export const createValidationErrorsGetter = (errorList: ValidationError[]) => {
  return (sectionId: SectionId): ValidationError[] => {
    const errorIds = ERROR_MAP[sectionId] || [];
    return errorList.filter((error) => errorIds.includes(error.id));
  };
};

